export default "__VITE_ASSET__Qv6fnh0m__"